import { render, staticRenderFns } from "./UserAddressCard.vue?vue&type=template&id=16f04b4a&scoped=true&"
import script from "./UserAddressCard.vue?vue&type=script&lang=js&"
export * from "./UserAddressCard.vue?vue&type=script&lang=js&"
import style0 from "./UserAddressCard.vue?vue&type=style&index=0&id=16f04b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f04b4a",
  null
  
)

export default component.exports